// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/right-hand.css
 ** module id = 204
 ** module chunks = 0
 **/